import { render, staticRenderFns } from "./deactivate.vue?vue&type=template&id=370e0eda&scoped=true&"
import script from "./deactivate.vue?vue&type=script&lang=js&"
export * from "./deactivate.vue?vue&type=script&lang=js&"
import style0 from "./deactivate.vue?vue&type=style&index=0&id=370e0eda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370e0eda",
  null
  
)

export default component.exports